export enum EntityType {
    Area = "MultiCmsLibrary\\SharedModels\\Models\\Area",
    Backlink = "MultiCmsLibrary\\SharedModels\\Models\\Backlink",
    BacklinkCategory = "MultiCmsLibrary\\SharedModels\\Models\\BacklinkCategory",
    Category = "MultiCmsLibrary\\SharedModels\\Models\\Category",
    Column = "MultiCmsLibrary\\SharedModels\\Models\\Column",
    CsvFile = "MultiCmsLibrary\\SharedModels\\Models\\CsvFile",
    CsvRecord = "MultiCmsLibrary\\SharedModels\\Models\\CsvRecord",
    Customer = "MultiCmsLibrary\\SharedModels\\Models\\Customer",
    Domain = "MultiCmsLibrary\\SharedModels\\Models\\Domain",
    File = "MultiCmsLibrary\\SharedModels\\Models\\File",
    Menu = "MultiCmsLibrary\\SharedModels\\Models\\Menu",
    MenuItem = "MultiCmsLibrary\\SharedModels\\Models\\MenuItem",
    Page = "MultiCmsLibrary\\SharedModels\\Models\\Page",
    Product = "MultiCmsLibrary\\SharedModels\\Models\\Product",
    Tag = "MultiCmsLibrary\\SharedModels\\Models\\Tag",
    User = "MultiCmsLibrary\\SharedModels\\Models\\User",
    Widget = "MultiCmsLibrary\\SharedModels\\Models\\Widget",
    WidgetArea = "MultiCmsLibrary\\SharedModels\\Models\\WidgetArea",
  }
  